import { render, staticRenderFns } from "./zakaz-login.vue?vue&type=template&id=4dda94dd&scoped=true"
import script from "./zakaz-login.vue?vue&type=script&lang=js"
export * from "./zakaz-login.vue?vue&type=script&lang=js"
import style0 from "./zakaz-login.vue?vue&type=style&index=0&id=4dda94dd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dda94dd",
  null
  
)

export default component.exports